const hasCompanyId = (value) => value !== null && value !== undefined && value !== '';

const sameCompany = (left, right) => hasCompanyId(left) && hasCompanyId(right) && String(left) === String(right);

const isThirdPartyDevice = (device) => device?.is_third_party === true
  || device?.is_third_party === 1
  || device?.is_third_party === '1'
  || hasCompanyId(device?.third_party_device_manufacturer_id);

export function resolveHardwareImageUrl({model, type, ownerCompanyId, allowTypeFallback = true, fallback = null} = {}) {
  if (model?.image_url) {
    return model.image_url;
  }

  if (!allowTypeFallback) {
    return fallback;
  }

  if (!type?.image_url) {
    return fallback;
  }

  if (hasCompanyId(model?.company_id) && !sameCompany(type.company_id, model.company_id)) {
    return fallback;
  }

  if (!hasCompanyId(type.company_id)) {
    return type.image_url;
  }

  if (sameCompany(type.company_id, model?.company_id) || sameCompany(type.company_id, ownerCompanyId)) {
    return type.image_url;
  }

  return fallback;
}

export function resolveDeviceImageUrl(device, fallback = null) {
  return resolveHardwareImageUrl({
    model: device?.device_model,
    type: device?.device_type,
    ownerCompanyId: device?.company_id,
    allowTypeFallback: !isThirdPartyDevice(device),
    fallback,
  });
}

export function resolveRevisionImageUrl(revision, fallback = null) {
  return resolveHardwareImageUrl({
    model: revision?.device_model,
    type: revision?.device_type,
    fallback,
  });
}
